import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type PromoCodeFragment = { id: string, pk: number, availability: boolean, name: string, description: string, startDate: any, endDate: any | null, value: any, valueType: string, token: string, style: any, conditionsAfterVerification: Array<{ variant: Types.PromoCodeConditionVariantEnum, status: Types.PromoCodeConditionStatusEnum, label: string }>, validCartProducts: Array<{ id: string, name: string }> };

export const PromoCodeFragmentDoc = gql`
    fragment PromoCodeFragment on PromoCodeType {
  id
  pk
  availability
  name
  description
  startDate
  endDate
  value
  valueType
  token
  conditionsAfterVerification {
    variant
    status
    label
  }
  validCartProducts {
    id
    name
  }
  style
}
    `;